import { FC, PropsWithChildren } from 'react';
import './DashboardTableCustomer.scss';

export const DashboardTableCustomer: FC<PropsWithChildren> = ({ children }) => {
  return <div className="DashboardTableCustomer">{children}</div>;
};
